export const getSkeletonWidth = (
  min: number,
  max: number,
  unit: 'px' | 'ch' | 'rem' | '%' = 'px'
) => {
  const random = Math.random()
  return `${random * (max - min) + min}${unit}`
}
